import { Middleware } from '@reduxjs/toolkit'
import { fetchContribution, fetchNextSlide, fetchPrevSlide } from '../store/contributions/contributionsSlice'
import { fetchContributionComments } from '../store/comments/commentsSlice'
import { RootState } from '../store/rootReducer'

export const contributionMiddleware: Middleware<{}, RootState> = (store) => (next) => (action) => {
    const contributionActions = [fetchContribution.fulfilled, fetchNextSlide.fulfilled, fetchPrevSlide.fulfilled]

    if (contributionActions.some((a) => a.match(action))) {
        const contribution = action.payload.contribution
        if (contribution && contribution.id) {
            const state = store.getState()
            const key = `contribution:${contribution.id}`

            if (!state.comments.byTarget[key]) {
                store.dispatch(
                    //@ts-ignore
                    fetchContributionComments({
                        object_type: 'contribution',
                        object_id: contribution.id,
                        offset: 0,
                        limit: 10
                    })
                )
            }
        }
    }

    return next(action)
}
